import React, { useState, useRef } from "react";
import "./ToolbarDragger.css";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";

let startY = 0;
let startWidth = 0;

function ToolbarDragger() {
  const draggerRef = useRef();
  const initDrag = () => {
    const { current: dragger } = draggerRef;
    startY = dragger.getBoundingClientRect().y;
    startWidth = document.querySelector(".toolbar").getBoundingClientRect()
      .height;

    dragger.addEventListener("touchmove", (e) => {
      e.preventDefault();
      const draggedY = e.touches[0].clientY;
      const addedY = startY - draggedY;
      // document.querySelector(".textEditor").innerText = draggedY;
      if (draggedY > 120 && draggedY < 340) {
        document.querySelector(".toolbar").style["height"] =
          startWidth + addedY + "px";
      }
    });
  };
  return (
    <div className="toolbarDragger" onTouchStart={initDrag} ref={draggerRef}>
      <ExpandLessIcon />
    </div>
  );
}
// document.body.addEventListener("touchmove", function (e) {
//   e.preventDefault();
// });

export default ToolbarDragger;
